import React from "react";
import { GoPrimitiveDot } from "react-icons/go";

const Dot = ({ text }) => {
  return (
    <div
      className="notification-dot"
      title={`Alert notification icon for ${text}`}
    >
      <GoPrimitiveDot />
    </div>
  );
};
export default Dot;
